import { createIcon } from '@chakra-ui/icons';

// hugeicons "cancel-circle" — the Absent stat tile (Workshops Figma 1943:16818).
export const CancelCircleStroke = createIcon({
  displayName: 'CancelCircleStroke',
  viewBox: '0 0 24 24',
  path: (
    <g transform="translate(1 1)">
      <path fill="none" d="M21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21C16.5228 21 21 16.5228 21 11Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path fill="none" d="M13.9994 14L8 8M8.00064 14L14 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </g>
  ),
});
